import { useEffect, useState } from "react";
import { API_URL } from "../config";
import FiltersAssignee from "../components/filters/FiltersAssignee";
import BooksTableView from "../components/BooksTableView";

function BooksData() {
  const [availableAssignees, setAvailableAssignees] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/assignees`)
      .then((res) => res.json())
      .then((data) =>
        setAvailableAssignees(data.map((item) => ({ value: item.assignee, label: item.assignee })))
      )
      .catch((err) => console.error("Error loading assignees:", err));
  }, []);

  return (
    <div className="container">
      <h1>Books Data</h1>
      <FiltersAssignee
        availableAssignees={availableAssignees}
        selectedAssignee={selectedAssignee}
        setSelectedAssignee={setSelectedAssignee}
      />
      <BooksTableView selectedAssignee={selectedAssignee} />
    </div>
  );
}

export default BooksData;
